module.exports = __webpack_public_path__ + "img/director-school-icon7.afa434c6.jpg";